/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';
import DialogBox from './DialogBox';
import DialogClose from './DialogClose';
import DialogTitle from './DialogTitle';
import { Modal, Overlay } from '@entrata/portals-common/lib/components';
import { css } from 'emotion';
import { homeBodyTheme } from 'constants/theme';
import { transparentize } from 'polished';

const wrapperClass = css`
  width: 100vw;
  height: 100vh;
  display: block;
  padding: 40px 24px;
  position: fixed;
  top: 0;
  left: 0;
  text-align: center;
  z-index: 999;
  background-color: rgba(0, 75, 55, 0.8);

  &:before {
    content: '';
    display: inline-block;
    height: 100vh;
    vertical-align: middle;
  }
`;

const Dialog = ({ children, duration, onClose, render, show, title, customStyle = null }) => (
  <Transition in={show} mountOnEnter unmountOnExit timeout={duration}>
    {(status) => (
      <Modal className={wrapperClass} timeout={duration} onClose={onClose}>
        {({ containerProps, titleId }) => (
          <React.Fragment>
            <Overlay color={transparentize(0.5, homeBodyTheme.secondary.dark)} duration={duration} status={status} />
            {typeof render === 'function' ? (
              render({
                delay: /^enter/.test(status) ? 100 : 0,
                duration,
                containerProps,
                titleId,
                status,
              })
            ) : (
              <DialogBox
                delay={/^enter/.test(status) ? 100 : 0}
                duration={duration}
                status={status}
                {...containerProps}
                {...customStyle}
              >
                <DialogClose onClick={onClose} />
                {title && <DialogTitle id={titleId}>{title}</DialogTitle>}
                {children}
              </DialogBox>
            )}
          </React.Fragment>
        )}
      </Modal>
    )}
  </Transition>
);

Dialog.propTypes = {
  children: PropTypes.any,
  duration: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  render: PropTypes.func,
  show: PropTypes.bool,
  title: PropTypes.string,
  customStyle: PropTypes.object,
};

Dialog.defaultProps = {
  duration: 350,
};

export default Dialog;
